// extracted by mini-css-extract-plugin
module.exports = {"share":"styles_share__3nlal","popup":"styles_popup__1RiLq","icons":"styles_icons__3VtiK"};